import { useEffect } from "react";

/**
 * Sets per-page <head> metadata for SEO + social link previews.
 * Updates title, meta description, OG title/description/url and twitter equivalents.
 * Restores the document-level defaults on unmount.
 */
export default function usePageMeta({ title, description, path } = {}) {
  useEffect(() => {
    const prevTitle = document.title;

    const ensureMeta = (selector, attrs) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
        document.head.appendChild(el);
      }
      return el;
    };

    const prev = {};
    const set = (sel, attrs, value) => {
      const el = ensureMeta(sel, attrs);
      prev[sel] = el.getAttribute("content");
      el.setAttribute("content", value);
    };

    if (title) {
      document.title = title;
    }
    if (description) {
      set('meta[name="description"]', { name: "description" }, description);
      set('meta[property="og:description"]', { property: "og:description" }, description);
      set('meta[name="twitter:description"]', { name: "twitter:description" }, description);
    }
    if (title) {
      set('meta[property="og:title"]', { property: "og:title" }, title);
      set('meta[name="twitter:title"]', { name: "twitter:title" }, title);
    }
    if (path) {
      const fullUrl = `https://seayisyen.net${path}`;
      set('meta[property="og:url"]', { property: "og:url" }, fullUrl);
    }

    return () => {
      document.title = prevTitle;
      Object.entries(prev).forEach(([sel, value]) => {
        const el = document.head.querySelector(sel);
        if (el && value != null) el.setAttribute("content", value);
      });
    };
  }, [title, description, path]);
}
